import { ActionType } from "typesafe-actions";

import * as actions from "./actions";

export type ConversionsWidgetAction = ActionType<typeof actions>;

export interface ConversionsValue {
  value?: number;
  previousValue?: number;
}

export enum ConversionsWidgetActionTypes {
  FETCH_REQUEST = "@ConversionsWidget/FETCH_REQUEST",
  FETCH_SUCCESS = "@ConversionsWidget/FETCH_SUCCESS",
  FETCH_ERROR = "@ConversionsWidget/FETCH_ERROR",

  PREVIOUS_FETCH_REQUEST = "@ConversionsWidget/PREVIOUS_FETCH_REQUEST",
  PREVIOUS_FETCH_SUCCESS = "@ConversionsWidget/PREVIOUS_FETCH_SUCCESS",
  PREVIOUS_FETCH_ERROR = "@ConversionsWidget/PREVIOUS_FETCH_ERROR",
}

export interface ConversionsWidgetState {
  readonly lastUpdate?: string;

  readonly dateFrom?: string;
  readonly previousDateFrom?: string;

  readonly dateTo?: string;
  readonly previousDateTo?: string;

  readonly searches?: number;
  readonly previousSearches?: number;

  readonly clicks?: number;
  readonly previousClicks?: number;

  readonly bookings?: number;
  readonly previousBookings?: number;

  readonly isLoading: boolean;
  readonly isPreviousLoading: boolean;
}

export interface ConversionsWidgetResponse {
  searches?: number;
  clicks?: number;
  bookings?: number;
  dateFrom: string;
  dateTo?: string;
  lastUpdate: string;
}
